/**
 * Adree Theme — Main JavaScript Entry Point
 */

import 'bootstrap';

import { initNavigation } from './navigation';
import { initSlider } from './slider';
import { initAnimations } from './animations';
import { initLoader } from './loader';
import { initNewsletter } from './newsletter';

// Initialize loader immediately
initLoader();

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initSlider();
  initAnimations();
  initNewsletter();
});
